var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.757 23.2619L31.9681 29.7282C31.3098 32.1068 28.7547 32.4239 27.5144 30.3025L21.1638 19.4416L15.6181 28.0165C14.431 29.8508 12.0712 29.8628 10.8721 28.0336L8.3401 24.1679L7.18038 25.3568C6.19467 26.3682 4.61753 26.777 3.24181 26.4479V31.1039C3.24181 33.1936 4.36724 34.2582 6.37553 34.2582H30.6438C32.6324 34.2582 33.7578 33.1936 33.7578 31.1039L33.757 23.2619ZM33.757 10.4048V6.89732C33.757 4.80761 32.6324 3.74304 30.6438 3.74304H6.37553C4.36724 3.74304 3.24181 4.80761 3.24181 6.89732V22.7288L3.97896 23.0922C4.16153 23.1813 4.58324 23.1093 4.72638 22.9628L6.1801 21.4713C7.60638 20.0082 9.85724 20.2268 10.9767 21.9359L13.2361 25.3842L18.8658 16.6808C20.0744 14.8122 22.4598 14.8636 23.5835 16.7862L29.2912 26.5473L33.757 10.4048ZM6.31638 37.493C2.13781 37.493 0.0078125 35.4239 0.0078125 31.2659V6.73447C0.0078125 2.57647 2.13781 0.507324 6.31638 0.507324H30.7047C34.9038 0.507324 36.9927 2.59618 36.9927 6.73447V31.2659C36.9927 35.4042 34.9038 37.493 30.7047 37.493H6.31638Z",
    fill: "#E1E1E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphAlt);
export default __webpack_public_path__ + "static/media/graph_alt.b780fba5b48d259a75dbe3c6fcaa2d8f.svg";
export { ForwardRef as ReactComponent };